import { ReparoApi } from './index';

export type MaterialType = 'RM' | 'PM' | 'STAGE';

/** Stage stock (a cut/processed form of the raw) that covers FG units before the raw is touched. */
export type FgComponentAlternate = {
    materialId: string;
    materialName: string;
    unit: string;
    qtyPerFg: number;
    availableQty: number;
    maxFgUnits: number;
};

export type FgComponent = {
    materialId: string;
    materialSku: string | null;
    materialName: string;
    materialType: MaterialType;
    unit: string;
    qtyPerFg: number;
    availableQty: number;
    /** Raw + stage stock, in FG units. */
    maxFgUnits: number;
    rawMaxFgUnits?: number;
    alternateMaxFgUnits?: number;
    alternates?: FgComponentAlternate[];
    isBottleneck: boolean;
};

export type FgPortfolioRow = {
    productId: string;
    productSku: string | null;
    productName: string;
    fgEquivalent: number;
    consumptionPerDay: number | null;
    daysOnHand: number | null;
    bottleneckMaterialId: string | null;
    bottleneckMaterialSku: string | null;
    bottleneckMaterialName: string | null;
    manufacturingLeadTimeDays: number | null;
    components: FgComponent[];
};

export const getFgPortfolio = async (payload: {
    wastagePercent?: number;
}): Promise<FgPortfolioRow[]> => {
    return ReparoApi<any>({
        method: 'POST',
        url: '/production-planning/fg-calculator/portfolio',
        body: JSON.stringify(payload),
    });
};
